import React from "react";
import { Header, Footer } from "../LandingPage/LandingPage";

const AboutPage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-white text-gray-800">
      <Header />

      <main className="flex-grow container mx-auto px-4 py-16 max-w-5xl">
        <h1 className="text-4xl font-bold mb-6 text-center text-gray-900">
          About Gradiance
        </h1>

        <p className="text-lg text-gray-700 mb-8 text-center max-w-3xl mx-auto">
          Gradiance is a modern Indian brand built on the vision of redefining surface finishes. From interior and exterior paints to cutting-edge waterproofing and putty solutions, we offer products that combine quality, innovation, and reliability.
        </p>

        <section className="grid md:grid-cols-2 gap-10">
          <div>
            <h2 className="text-2xl font-semibold mb-3">Who We Are</h2>
            <p className="text-gray-700 leading-relaxed">
              We're a passionate team of creators, engineers, and designers working to deliver excellence in the paints and coatings industry. With a customer-first mindset and focus on long-lasting performance, Gradiance ensures every product meets the highest standards of quality.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold mb-3">Our Mission</h2>
            <p className="text-gray-700 leading-relaxed">
              To make high-quality wall finishes accessible, aesthetic, and sustainable - enabling people to build, renovate, and protect their spaces with confidence.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold mb-3">Why Choose Gradiance?</h2>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>Wide range of products for interiors, exteriors, and waterproofing</li>
              <li>Stringent quality checks and consistency</li>
              <li>Customer-focused service and support</li>
              <li>Modern branding and packaging tailored for trust</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-semibold mb-3">Sustainability Commitment</h2>
            <p className="text-gray-700 leading-relaxed">
              We're committed to minimizing environmental impact by promoting safer, low-VOC formulations and responsible production practices. Our focus on sustainability ensures that your walls - and the world - stay beautiful for years to come.
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default AboutPage;
